import { createSlotAndPlug } from "react-view-slot"


export const [CommunityFavoritesDescriptionSlot, CommunityFavoritesDescriptionPlug] = createSlotAndPlug("community_favorites_description")

export const [CommunityFavoritesImageSlot, CommunityFavoritesImagePlug] = createSlotAndPlug("community_favorites_image")
